import React, { Fragment } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { H1, H3 } from './typography';
import { dark } from '../theme';
import { Link } from '@reach/router';
import logo from '../assets/images/logo.png';
import responsive from '../utils/responsive';
import theme from '../theme';

const Grid = styled.div`
  display: grid;

  grid-template-columns: 0.4fr repeat(3, 1fr);
  grid-template-rows: 30em;

  ${responsive.sm.andSmaller`
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, minmax(20em, 1fr));
  `}

  ${responsive.xs.andSmaller`
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, minmax(15em, 1fr));
  `}

  grid-gap: 2px;
  align-items: stretch;
  justify-items: stretch;
  width: 100%;
  text-align: center;
  border-top: solid 1px white;
  border-bottom: solid 1px white;
  overflow-x: hidden;
  box-sizing: border-box;
`;

const RoomItem = styled.div`
  position: relative;
  background: ${props =>
    props.background
      ? `url(${props.background})`
      : props.theme.backgroundColor.toHex()};

  background-size: cover;
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  ${responsive.md.andSmaller`
    > h1 {
      font-size: 1.4em;
    }
  `}
`.withComponent(Link);

const RoomTitle = styled.div`
  position: relative;
  background: ${props => props.theme.colors.primary.toHex()};
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;

  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
`;

const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: ${theme.colors.primary.toHex()};
  opacity: 0.3;
  : hover {
    opacity: 0;
  }
  transition: all 0.1s ease;

  ${responsive.md.andSmaller`
    opacity: 0.2;
  `}
`;

const Logo = styled.img`
  width: 70%;
  object-fit: contain;

  ${responsive.sm.andSmaller`
    height: 40%;
  `}
`;

const Room = ({ id, name, background }) => (
  <RoomItem
    background={background}
    to={`/room/${id}`}
    onClick={() => window.scrollTo(0, 0)}
  >
    <Backdrop />
    <H1 style={{ zIndex: 1, pointerEvents: 'none' }}>{name}</H1>
  </RoomItem>
);

const RoomPicker = ({ rooms, content }) => (
  <ThemeProvider theme={dark}>
    <Grid>
      <Fragment>
        <RoomTitle>
          <Logo src={logo} alt={'LaVilla Logo'} />
          <H3 style={{ marginTop: 0 }}>{content.general.rooms}</H3>
        </RoomTitle>
        {rooms.map(room => (
          <Room key={room.id} {...room} />
        ))}
      </Fragment>
    </Grid>
  </ThemeProvider>
);

export default RoomPicker;
